import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';

@Injectable({
    providedIn: 'root'
})

export class GroupService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "group");
    }
}
